/**
 * The one URL the "Buy $SLPS on Pons" chip may point at.
 *
 * `docs/02-gtm-plan.md` names ponsfamily.com as the only official Pons domain
 * and pons.fun / pons.xyz as lookalikes, so anything that is not an https
 * link on ponsfamily.com is rejected here rather than rendered. A bare
 * homepage is rejected too: a link to the launchpad's front page would imply
 * the token is buyable when it may not exist yet. Nothing is ever invented —
 * no URL in, no chip link out.
 */
const OFFICIAL_HOSTS = new Set(['ponsfamily.com', 'www.ponsfamily.com']);

export function officialPonsUrl(raw: string | null | undefined): string | null {
  const value = raw?.trim();
  if (!value) return null;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  if (url.username || url.password || url.port) return null;
  if (!OFFICIAL_HOSTS.has(url.hostname.toLowerCase())) return null;
  // `//` and `///` stay the homepage — the URL parser does not collapse them —
  // and a homepage link would claim the token is buyable when it may not be.
  if (!url.pathname.split('/').some((segment) => segment.length > 0)) return null;
  return url.toString();
}
